export class UserEditRequestDto {
    public name?: string
    public password?: string
    public accounts?: any[]
}
